/**
 * 复制文本到剪贴板。
 * 优先使用 navigator.clipboard（安全上下文）；否则用 Range + Selection + execCommand，
 * 与 ResetPasswordDialog 一致，不依赖 textarea focus，在 PC 端 Drawer/弹层内也能生效。
 */
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  /** 使用选区复制，不依赖 focus，PC 端在 Dialog/Drawer 内也可用 */
  const fallbackCopy = (value: string): boolean => {
    try {
      const selection = window.getSelection();
      const range = document.createRange();
      const node = document.createTextNode(value);
      const wrapper = document.createElement('div');
      wrapper.appendChild(node);
      document.body.appendChild(wrapper);

      range.selectNodeContents(wrapper);
      selection?.removeAllRanges();
      selection?.addRange(range);

      const ok = document.execCommand('copy');
      document.body.removeChild(wrapper);
      selection?.removeAllRanges();
      return ok;
    } catch {
      return false;
    }
  };

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return fallbackCopy(text);
    }
  }

  return fallbackCopy(text);
}
